import { useApolloClient } from '@apollo/react-hooks';
import { remove } from 'lodash/fp';
import { PENDING_TERM_AND_CONDITION_USERS } from '../GraphQL/Queries';
import logger from '../logger';

const useTermAndConditionUserCache = (schoolId, eventId) => {
  const client = useApolloClient();
  const updateCache = (user, action = 'add') => {
    try {
      const data = client.readQuery({
        query: PENDING_TERM_AND_CONDITION_USERS,
        variables: {
          eventId: parseInt(eventId, 10),
          schoolId: parseInt(schoolId, 10),
        },
      });
      const { fetchPendingTermAndConditionUsers } = data;
      let response = [];
      if (action === 'add') {
        response = fetchPendingTermAndConditionUsers.unshift(user);
      } else {
        response = remove((u) => parseInt(u.userId, 10)
          === parseInt(user.id, 10))(fetchPendingTermAndConditionUsers);
      }
      client.writeQuery({
        query: PENDING_TERM_AND_CONDITION_USERS,
        data: {
          fetchPendingTermAndConditionUsers: response,
        },
        variables: {
          eventId: parseInt(eventId, 10),
          schoolId: parseInt(schoolId, 10),
        },
      });
    } catch (e_) {
      logger('Update not needed!');
    }
  };

  return updateCache;
};

export default useTermAndConditionUserCache;
